import type { PermissionTuple } from '~/utils/ability'

/** Voir l'onglet Pilotage et ses données. */
export const PILOTAGE_READ: PermissionTuple = ['read', 'previsions.pilotage.pilotage']
/** Ajuster la prévision officielle et régler les coefs de sécurité. */
export const PILOTAGE_EDIT: PermissionTuple = ['edit', 'previsions.pilotage.pilotage']
